import { createContext } from "react";
export const AppTextContext = createContext<(key: string) => string>(
  key => key
);
